import { DeleteFilesResponse, DownloadResponse, Response } from '@opp/shared';
import { apiRequest } from './api';

export async function getDownloadUrl(params: {
  key: string;
  filename?: string;
  contentType?: string;
}) {
  const search = new URLSearchParams({ key: params.key });
  if (params.filename) search.set('filename', params.filename);
  if (params.contentType) search.set('contentType', params.contentType);

  return apiRequest<Response<DownloadResponse>>(`/common/download?${search.toString()}`, {
    method: 'GET',
  });
}

export async function deleteFiles(params: { keys: string[] }) {
  return apiRequest<Response<DeleteFilesResponse>>(`/common/delete`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
}

